<template>
    <div id="box">
        <div style="margin-top: 20px">
            <span style="margin-left: 30px;font-size: 16px"> 客户信息:  </span>
            <el-input v-model="input" placeholder="客户姓名、客户电话、客户店铺名称" style="width: 300px;
         margin-left: 10px"></el-input>
            <span style="margin-left: 30px;font-size: 16px;"> 所属区域:  </span>
            <el-form ref="form" :model="form" label-width="100px" style="width: 200px;float: right;
            margin-right: 390px">
                <el-cascader
                        :options="CityInfo"
                        v-model="form.selectedOptions"
                        @change="handleChange"
                >
                </el-cascader>
            </el-form>
            <el-button type="primary" icon="el-icon-search" style="position: absolute;right: 280px;top:21px;
            font-size: 12px" @click="search()">搜索</el-button>
            <el-button type="info" style="position: absolute;right: 150px;top:21px;
            font-size: 12px" icon="el-icon-delete" @click="empty()">清空</el-button>
        </div>
        <el-button type="primary" style="margin-left: 30px;margin-top: 10px"
                 @click="addForm"  >新增客户对账单</el-button>
        <!--表格部分-->
        <template>
            <el-table
                    :data="tableData"
                    border
                    style="width: 95%;margin-left: 30px;margin-top: 15px">
                <el-table-column
                        prop="name"
                        label="客户姓名"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="mobile"
                        label="客户电话"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="shopName"
                        label="客户店铺"
                        width="600px">
                </el-table-column>
                <el-table-column
                        prop="area"
                        label="所属区域"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="num"
                        label="进货单总数量"
                        width="auto">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <!--<el-button plain-->
                                   <!--size="mini"-->
                                   <!--type="primary"-->
                                   <!--:disabled="scope.row.status!='RETURNED'?true:false"-->
                                   <!--@click="show2(scope.$index, scope.row)">编辑</el-button>-->
                        <el-button plain
                                   size="mini"
                                   type="primary"
                                   @click="func (scope.row.shopId)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="block" style="text-align: right;margin-right: 30px;margin-top: 20px">
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-size="pageSize"
                        layout="total, prev, pager, next"
                        :total="total">
                </el-pagination>
            </div>
        </template> <!--表格结束-->
        <!--新增弹出框-->
        <el-dialog title="新增客户对账单" :visible.sync="add" :before-close="handleClose">
            <el-form >
                <el-form-item label="客户电话:">
                    <el-input v-model="mobile" style="width: 500px" @change="getShopId()"></el-input>
                </el-form-item>
                <el-form-item label="客户姓名:">
                    <el-input v-model="name" style="width: 500px" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="客户店铺:">
                    <el-input v-model="store" style="width: 500px" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="客户区域:" >
                    <el-form ref="form2" :model="form2" label-width="100px" style="width: 230px;float: left;">
                        <el-input v-model="address" style="width: 500px" :disabled="true"></el-input>
                    </el-form>
                </el-form-item>
                <el-form-item label="请选择客户负责人:" style="width: 300px;">
                    <el-select v-model="departmentAddValue" placeholder="请选择部门" @change="chooseDepartment">
                        <el-option style="width: 300px;"
                                v-for="item in departmentAdd"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  style="width: 300px;float: right;margin-top: -62px;margin-right: 30px">
                    <el-select v-model="staffAddValue" placeholder="请选择员工" >
                        <el-option style="width: 300px;"
                                   v-for="item in staffAdd"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="请选择对账时间范围:" style="width: 300px">
                    <el-date-picker style="width: 300px"
                            value-format="yyyy-MM-dd"
                            v-model="addStartDate"
                            type="date"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item  style="width: 300px;float: right;margin-top: -62px;margin-right: 30px">
                    <el-date-picker style="width: 300px"
                                    value-format="yyyy-MM-dd"
                                    v-model="addEndDate"
                                    type="date"
                                    placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <!--<el-form-item label="请输入客户确认天数:">-->
                    <!--<br>-->
                    <!--<el-input v-model="days" style="width: 600px"></el-input>-->
                <!--</el-form-item>-->
                <el-form-item label="客户本期对账进货总金额:">
                    <br>
                    <el-input v-model="totalMoney1" style="width: 600px" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="客户账户总余额:">
                    <br>
                    <el-input v-model="totalMoney2" style="width: 600px" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="请输入客户进货明细:">
                    <el-table
                            :data="detail"
                            border>
                        <el-table-column
                                align="center"
                                label="单据编码">
                            <template slot-scope="scope">
                                <el-input type="input" name="coding" v-model="detail[scope.$index].coding"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="进货日期">
                            <template slot-scope="scope">
                                <el-date-picker
                                        value-format="yyyy-MM-dd"
                                        type="date"
                                        v-model="detail[scope.$index].date"
                                        placeholder="选择日期">
                                </el-date-picker>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="业务金额">
                            <template slot-scope="scope">
                                <el-input type="input" name="money" v-model="detail[scope.$index].money"
                                          @change="countMoney"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="单据凭证">
                            <template slot-scope="scope">
                                <div @click="uploadAddIndex(scope.$index)">
                                <el-upload :multiple="true" action="#" accept="image/jpeg,image/gif,image/png,image/bmp"
                                           :file-list="uploadImg" :http-request="fnUploadBusinessRequest" :show-file-list="false">
                                    <div v-if="'' != detail[scope.$index].imgArray" class="el-upload el-upload--picture-img">
                                        <img v-for="src of detail[scope.$index].imgArray" :src="src" style="width: 200px;"/>
                                    </div>
                                    <div v-else class="el-upload el-upload--car-two">
                                        <i
                                                class="el-icon-plus"></i>
                                    </div>
                                </el-upload>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="操作">
                            <template slot-scope="scope">
                                <el-button plain
                                           icon="el-icon-check"
                                           size="mini"
                                           type="warning"
                                           @click="deleteRows(scope.$index, scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="margin-top: 20px">
                        <el-button @click="AddRows()" type="success">增加一行</el-button>
                    </div>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addClose">重 置</el-button>
                <el-button type="primary" @click="addDrafts">保存草稿箱</el-button>
                <el-button type="primary" @click="addSure">发送对账单</el-button>
                <el-button type="success" style="display: none">导入请先下载模板</el-button>
                <el-button type="success" style="display: none">
                    <input type="file" @change="importf(this)" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
                </el-button>
            </div>
        </el-dialog> <!--新增弹出框结束-->
        <!--编辑弹出框-->
        <el-dialog title="编辑客户对账单" :visible.sync="edit">
            <el-form >
                <el-form-item label="客户电话:">
                    <el-input  style="width: 500px" v-model="editData.mobile"></el-input>
                </el-form-item>
                <el-form-item label="客户姓名:">
                    <el-input  style="width: 500px" :disabled="true" v-model="editData.name"></el-input>
                </el-form-item>
                <el-form-item label="客户店铺:">
                    <el-input  style="width: 500px" :disabled="true" v-model="editData.shopName"></el-input>
                </el-form-item>
                <el-form-item label="客户区域:" >
                    <el-input  style="width: 500px" :disabled="true" v-model="editData.area"></el-input>
                </el-form-item>
                <el-form-item label="请选择客户负责人:" style="width: 300px;">
                    <el-select  placeholder="请选择部门" :disabled="true">
                        <el-option style="width: 300px;"
                                  v-model="editData.departmentName"
                                   :value="editData.departmentName"
                                   v-for="item in departmentAdd"
                                   :key="item.value"
                                   :label="item.label"
                                   >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  style="width: 300px;float: right;margin-top: -62px;margin-right: 30px">
                    <el-select  placeholder="请选择员工" :disabled="true">
                        <el-option style="width: 300px;"
                                   v-model="editData.stuffName"
                                   :value="editData.stuffName"
                                   v-for="item in staffAdd"
                                   :key="item.value"
                                   :label="item.label"
                                   >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="请选择对账时间范围:" style="width: 300px">
                    <el-date-picker style="width: 300px"
                                    value-format="yyyy-MM-dd"
                                    v-model="editData.startTime"
                                    type="date"
                                    placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item  style="width: 300px;float: right;margin-top: -62px;margin-right: 30px">
                    <el-date-picker style="width: 300px"
                                    value-format="yyyy-MM-dd"
                                    v-model="editData.endTime"
                                    type="date"
                                    placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <!--<el-form-item label="请输入客户确认天数:">-->
                    <!--<br>-->
                    <!--<el-input style="width: 600px" v-model="editData.days" :disabled="true"></el-input>-->
                <!--</el-form-item>-->
                <el-form-item label="客户本期对账进货总金额:">
                    <br>
                    <el-input  style="width: 600px" :disabled="true" v-model="editMoney"></el-input>
                </el-form-item>
                <el-form-item label="客户账户总余额:">
                    <br>
                    <el-input  style="width: 600px" :disabled="true" v-model="editData.totalBalance"></el-input>
                </el-form-item>
                <el-form-item label="请输入客户进货明细:">
                    <el-table
                            :data="editDetail"
                            border>
                        <el-table-column
                                align="center"
                                label="单据编码">
                            <template slot-scope="scope">
                                <el-input type="input" name="coding"
                                v-model=" editDetail[scope.$index].documentsCoding"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="进货日期">
                            <template slot-scope="scope">
                                <el-date-picker
                                        value-format="yyyy-MM-dd"
                                        type="date"
                                        v-model="editDetail[scope.$index].stockTime"
                                        placeholder="选择日期">
                                </el-date-picker>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="业务金额">
                            <template slot-scope="scope">
                                <el-input type="input" name="money"
                                          v-model="editDetail[scope.$index].stockMoney"
                                @change="editMoneyChange"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="单据凭证">
                            <template slot-scope="scope">
                                <div @click="editIndex(scope.$index)">
                                <el-upload :multiple="true" action="#" accept="image/jpeg,image/gif,image/png,image/bmp"
                                           :file-list="editUploadImg" :http-request="fnUploadBusinessRequest2" :show-file-list="false">
                                    <div v-if="'' != editDetail[scope.$index].imgArray" class="el-upload el-upload--picture-img">
                                        <!--<img v-for="src of editDetail[scope.$index].imgArray" :src="src" style="width: 200px;"/>-->
                                        <img v-for="src in editDetail[scope.$index].imgArray" :src="src" :key="src" style="width: 200px;">

                                    </div>
                                    <div v-else class="el-upload el-upload--car-two">
                                        <i
                                                class="el-icon-plus"></i>
                                    </div>
                                </el-upload>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="操作">
                            <template slot-scope="scope">
                                <el-button plain
                                           icon="el-icon-check"
                                           size="mini"
                                           type="warning"
                                           @click="editDeleteRows(scope.$index, scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="margin-top: 20px">
                        <el-button @click="editAddRows()" type="success">增加一行</el-button>
                    </div>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="editSure">再次发送对账单</el-button>
                <el-button type="success" style="display: none">导入Excel</el-button>
            </div>
        </el-dialog><!--编辑弹出框结束-->
        <!--第一个查看-->
        <el-dialog
                title="客户账户进货对账单记录"
                :visible.sync="Look"
                width="60%"
        >
            <div style="margin-bottom: 20px">
                <span style="margin-right: 10px">2019-02-01</span>
                <span >至</span>
                <span style="margin-right: 10px">2019-02-28</span>
                <span style="margin-right: 10px">薛俊</span>
                <span>发送本期进货对账金额</span>
                <span style="margin-right: 10px">5000</span>
                <span style="margin-right: 10px">客户余额1000元</span>
                <span style="margin-right: 10px">已主动确认</span>
                <span style="color: skyblue;float: right;cursor: pointer">查看对账单</span>
            </div>

        </el-dialog>
        <!--查看弹出框-->
        <el-dialog title="客户对账单详情" :visible.sync="details">
            <el-form >
                <el-form-item label="客户电话:">
                    <el-input  style="width: 500px" :disabled="true" v-model="detailsData.mobile"></el-input>
                </el-form-item>
                <el-form-item label="客户姓名:">
                    <el-input  style="width: 500px" :disabled="true" v-model="detailsData.name"></el-input>
                </el-form-item>
                <el-form-item label="客户店铺:">
                    <el-input  style="width: 500px" :disabled="true" v-model="detailsData.shopName"></el-input>
                </el-form-item>
                <el-form-item label="客户区域:" >
                    <el-input  style="width: 500px" :disabled="true" v-model="detailsData.area"></el-input>
                </el-form-item>
                <el-form-item label="请选择客户负责人:" style="width: 300px;">
                    <el-input  style="width: 300px;margin-right: 30px" :disabled="true" v-model="detailsData.departmentName"></el-input>
                </el-form-item>
                <el-form-item  style="width: 300px;float: right;margin-top: -62px;margin-right: 30px">
                    <el-input  style="width: 300px" :disabled="true" v-model="detailsData.stuffName"></el-input>
                </el-form-item>
                <el-form-item label="请选择对账时间范围:" style="width: 300px">
                    <el-date-picker style="width: 300px"
                                    :disabled="true"
                                    value-format="yyyy-MM-dd"
                                    :value="detailsData.startTime"
                                    v-model="detailsData.startTime"
                                    type="date"
                                    placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item  style="width: 300px;float: right;margin-top: -62px;margin-right: 30px">
                    <el-date-picker style="width: 300px"
                                    :disabled="true"
                                    :value="detailsData.endTime"
                                    value-format="yyyy-MM-dd"
                                    v-model="detailsData.endTime"
                                    type="date"
                                    placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <!--<el-form-item label="请输入客户确认天数:">-->
                    <!--<br>-->
                    <!--<el-input style="width: 600px" :disabled="true" v-model="detailsData.days"></el-input>-->
                <!--</el-form-item>-->
                <el-form-item label="客户本期对账进货总金额:">
                    <br>
                    <el-input  style="width: 600px" :disabled="true" v-model="detailsData.currentTotalBalance"></el-input>
                </el-form-item>
                <el-form-item label="客户账户总余额:">
                    <br>
                    <el-input  style="width: 600px" :disabled="true" v-model="detailsData.totalBalance"></el-input>
                </el-form-item>
                <el-form-item label="对账单状态">
                    <br>
                    <el-input  style="width: 600px" :disabled="true" ></el-input>
                </el-form-item>
                <el-form-item label="客户确认状态">
                    <br>
                    <el-input  style="width: 600px" :disabled="true" ></el-input>
                </el-form-item>
                <el-form-item label="请输入客户进货明细:">
                    <el-table
                            :data="detailsDetail"
                            border>
                        <el-table-column
                                align="center"
                                label="单据编码">
                            <template slot-scope="scope">
                                <el-input type="input" name="coding" :disabled="true"
                                          v-model="detailsDetail[scope.$index].documentsCoding"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="进货日期">
                            <template slot-scope="scope">
                                <el-date-picker
                                        :disabled="true"
                                        value-format="yyyy-MM-dd"
                                        type="date"
                                        v-model="detailsDetail[scope.$index].stockTime"
                                        placeholder="选择日期">
                                </el-date-picker>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="业务金额">
                            <template slot-scope="scope">
                                <el-input type="input" name="money" :disabled="true"
                                          v-model="detailsDetail[scope.$index].stockMoney"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="单据凭证">
                            <template slot-scope="scope">
                                <img style="width: 100px;height: 100px;margin-top: 10px" :src="item" v-for="(item,index) in detailsImgList[scope.$index]">
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="success" @click="getPdf()" style="display: none">导出PDF</el-button>
            </div>
        </el-dialog><!--查看弹出框结束-->
    </div>
</template>

<script>
    import CityInfo from "@/plug-in/city-picker/city-data.js";
    import html2Canvas from 'html2canvas';
    import JsPDF from 'jspdf';
    import {DIC} from "@/const/dic";
    import {getAliyunPublicToken} from "@/api/oss/aliyun";
    import oss from 'ali-oss';
    import md5 from 'js-md5';
    import { findBillList,findUserBalance,findDepartment,findStaff,addBill,lookBillDetails,
        billEdit,findShop,addDrafts
    } from "@/api/salesCloud/bill";
    import { findMobileShop } from "@/api/salesCloud/balance";
    import {calculatedBalance} from "@/api/salesCloud/checkDetail"
    export default {
        name: "index",
        data(){
            return {
                CityInfo:[],
                form: {
                    city : '',
                    erae : '',
                    minerae : '',
                    selectedOptions: [],//地区筛选数组
                },
                form2: {
                    city : '',
                    erae : '',
                    minerae : '',
                    selectedOptions: [],//地区筛选数组
                },
                input:'',   //搜索输入框绑定数据
                city:"",
                erae:"",
                minerae:"",
                addCity:"",
                addErae:"",
                addMinerae:"",
                tableData:[         //表格数据

                ],
                add:false,   //是否显示新增弹出框
                //新增的数据
                mobile:'',   //新增的手机号
                name:'',     //新增的用户名
                store:'',    //新增的店铺
                address:'',  //新增的区域
                departmentAdd: [
                ],
                staffAdd: [
                ],
                departmentAddValue: '',     //新增部门value
                staffAddValue:'',           //新增员工value
                addStartDate:'',           //新增开始时间value
                addEndDate:'',             //新增结束时间value
                days:'',                  //新增的确认天数
                totalMoney1:0,           //新增的客户本期对账进货总金额
                totalMoney2:'',           //新增的客户账户总余额
                detail:[],                //新增行的数组,
                uploadImg:[],             //存放上传图片名称的数组
                //编辑的数据
                editData:[],           //编辑的数据存放
                edit:false,             //是否显示编辑弹出框
                editDetail:[],           //编辑新增行的数组
                editUploadImg:[],        //编辑上传图片名称的数组
                editImgList:[
                ] ,         //编辑显示图片的数组
                //查看详情的数据
                details:false,          //是否显示详情弹出框
                detailsData:[],            //详情的数据存放
                detailsDetail:[],           //详情新增行的数组
                detailsUploadImg:[],        //详情上传图片名称的数组
                detailsImgList:[] ,         //详情显示图片的数组
                businessLicense: [], //存放服务器图片数组
                businessLicense2: [], //存放服务器图片数组2
                addIndex:'',      //上传图片的下标
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 4 ,
                shopID:'',
                editMoney:0,
                editID:'',
                Look:false,
                totalMoney3:0
            }
        },
        created(){
            this.CityInfo=CityInfo;
            let parmas = {
                page: this.currentPage,
                size: this.pageSize,
                name:this.input,
                mobile:this.input,
                shopName:this.input,
                province:this.city,
                city:this.erae,
                area:this.minerae,
            };
            findBillList(parmas).then((res) => {
                let data = JSON.parse(res.data);

                 this.total=data.total;
                 for(let i=0;i<data.rows.length;i++){
                     data.rows[i].area=data.rows[i].province+data.rows[i].city+data.rows[i].area;
                 }
                this.tableData=data.rows;
                //console.log(this.tableData);
            });
        },
        methods:{
            //第一个查看
            oneLook(i,data){
                this.Look=true;
            },
            //导入excel
            importf(obj) {
                let _this = this;
                let inputDOM = this.$refs.inputer;   // 通过DOM取文件数据
                this.file = event.currentTarget.files[0];
                var rABS = false; //是否将文件读取为二进制字符串
                var f = this.file;
                var reader = new FileReader();
                //if (!FileReader.prototype.readAsBinaryString) {
                FileReader.prototype.readAsBinaryString = function(f) {
                    var binary = "";
                    var rABS = false; //是否将文件读取为二进制字符串
                    var pt = this;
                    var wb; //读取完成的数据
                    var outdata;
                    var reader = new FileReader();
                    reader.onload = function(e) {
                        var bytes = new Uint8Array(reader.result);
                        var length = bytes.byteLength;
                        for(var i = 0; i < length; i++) {
                            binary += String.fromCharCode(bytes[i]);
                        }
                        var XLSX = require('xlsx');
                        if(rABS) {
                            wb = XLSX.read(btoa(fixdata(binary)), { //手动转化
                                type: 'base64'
                            });
                        } else {
                            wb = XLSX.read(binary, {
                                type: 'binary'
                            });
                        }
                        // outdata就是你想要的东西 excel导入的数据
                        outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
                        // excel 数据再处理
                        let arr = []
                        outdata.map(v => {
                            let obj = {}
                            obj.mobile = v.客户手机
                            obj.area = v.客户区域
                            obj.money = v.入账金额
                            arr.push(obj)
                        })
                        _this.accountList = [...arr];
                        console.log( _this.accountList[0]);
                        _this.mobile=_this.accountList[0].mobile;
                        _this.money=_this.accountList[0].money;
                        _this.reload();
                    }
                    reader.readAsArrayBuffer(f);
                }
                if(rABS) {
                    reader.readAsArrayBuffer(f);
                } else {
                    reader.readAsBinaryString(f);
                }
            },
            //新增行的下标
            uploadAddIndex(i){
                this.addIndex=i;
            },
            //上传
            async fnUploadBusinessRequest(option) {
                this.tableLoading = true;
                getAliyunPublicToken().then((res) => {
                    let data = JSON.parse(res.data);
                    // console.log(data);
                    let client = new oss({
                        region: data.point,
                        endPoint: data.point,
                        accessKeyId: data.accessKeyId,
                        accessKeySecret: data.accessKeySecret,
                        Expiration: data.expiration,
                        bucket: data.bucketName,
                        stsToken: data.securityToken
                    });
                    const storeAs = md5(option.file.name);
                    client.multipartUpload(storeAs, option.file, {
                    }).then(results => {
                        let res = results.res.requestUrls;
                        let files = new Array();
                        for (let url in res) {
                            let file = new Object();
                            file.label = storeAs;
                            file.value = url;
                            files.push(file)
                        }
                        this.fileList = files;
                        let array= results.res.requestUrls[0].split("?");
                        //this.businessLicense.push(array[0]);

                            this.detail[this.addIndex].imgArray.push(array[0]);

                        this.tableLoading = false;
                        //console.log(this.businessLicense);
                    }).catch((err) => {
                        console.log(err);
                    });
                })
            },
            //编辑的上传
            async fnUploadBusinessRequest2(option) {
                this.tableLoading = true;
                getAliyunPublicToken().then((res) => {
                    let data = JSON.parse(res.data);
                    // console.log(data);
                    let client = new oss({
                        region: data.point,
                        endPoint: data.point,
                        accessKeyId: data.accessKeyId,
                        accessKeySecret: data.accessKeySecret,
                        Expiration: data.expiration,
                        bucket: data.bucketName,
                        stsToken: data.securityToken
                    });
                    const storeAs = md5(option.file.name);
                    client.multipartUpload(storeAs, option.file, {
                    }).then(results => {
                        let res = results.res.requestUrls;
                        let files = new Array();
                        for (let url in res) {
                            let file = new Object();
                            file.label = storeAs;
                            file.value = url;
                            files.push(file)
                        }
                        this.fileList = files;
                        let array= results.res.requestUrls[0].split("?");

                        var list = {
                            coding: "",
                            date:'',
                            money:'',
                            voucher:'',
                            imgArray:[],
                        };
                         this.editDetail.push(list);

                        this.editDetail[this.addIndex].imgArray.push(array[0]);
                        this.editDetail.splice(this.editDetail.length-1,1);

                        this.tableLoading = false;
                    }).catch((err) => {
                        console.log(err);
                    });
                })
            },
            editIndex(i){

                this.addIndex=i;
                console.log(this.addIndex);
            },
            //计算编辑的金额
            editMoneyChange(){
                this.editMoney=0;
                for(let i=0;i<this.editDetail.length;i++){
                    this.editMoney+=parseInt(this.editDetail[i].stockMoney);
                }
            },
            //新增计算总金额
            countMoney(){
                this.totalMoney1=0;
                this.totalMoney2=this.totalMoney3
              for(let i=0;i<this.detail.length;i++){
                  this.totalMoney1+=parseFloat(this.detail[i].money);
              }
                this.totalMoney2=parseFloat(this.totalMoney2-this.totalMoney1).toFixed(2)
            },
            //根据部门查询员工
            chooseDepartment(){
                //console.log(this.departmentAddValue);
                let id=this.departmentAddValue;
                findStaff(id).then((res) => {
                    let data = JSON.parse(res.data);
                    //console.log(data);
                    for(let i=0;i<data.length;i++){
                        this.staffAdd.push({
                            value: data[i].id,
                            label: data[i].name
                        })
                    }
                });
            },
            //输入手机号获取店铺信息
            getShopId(){
                let mobile=this.mobile;
                findMobileShop(mobile).then((res) => {
                    let data = JSON.parse(res.data);
                   // console.log(data);
                    if(data!='' || data!= null){

                        console.log(data);
                        this.name=data.name;
                        this.store=data.shopName;
                        this.shopID=data.id;
                        let shopId=data.id;
                        this.address=data.province+data.city+data.area;
                        calculatedBalance(shopId).then((res) => {
                            this.totalMoney2=res.data
                            this.totalMoney3=res.data
                            //console.log("row："+ JSON.stringify(JSON.parse(res.data)))
                        })

                        // findShop(shopId).then((res) => {
                        //     let data = JSON.parse(res.data);
                        //     let rows=data[0];
                        //     console.log(rows);
                        //     if(rows==[] || rows==null || rows==undefined){
                        //         this.totalMoney2=0;
                        //     }else {
                        //         this.totalMoney2=rows.balance;
                        //
                        //     }
                        // })
                    }
                })
            },
            //打印pdf
            getPdf(name) {
                let shareContent = document.body,//需要截图的包裹的（原生的）DOM 对象
                    width = shareContent.clientWidth, //获取dom 宽度
                    height = shareContent.clientHeight, //获取dom 高度
                    canvas = document.createElement("canvas"), //创建一个canvas节点
                    scale = 4; //定义任意放大倍数 支持小数
                canvas.width = width * scale; //定义canvas 宽度 * 缩放
                canvas.height = height * scale; //定义canvas高度 *缩放
                canvas.style.width = shareContent.clientWidth * scale + "px";
                canvas.style.height = shareContent.clientHeight * scale + "px";
                canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
                let opts = {
                    scale: scale, // 添加的scale 参数
                    canvas: canvas, //自定义 canvas
                    logging: false, //日志开关，便于查看html2canvas的内部执行流程
                    width: width, //dom 原始宽度
                    height: height,
                    useCORS: true, // 【重要】开启跨域配置
                };

                html2Canvas(shareContent, opts).then(() => {
                    var contentWidth = canvas.width;
                    var contentHeight = canvas.height;
                    //一页pdf显示html页面生成的canvas高度;
                    var pageHeight = (contentWidth / 592.28) * 841.89;
                    //未生成pdf的html页面高度
                    var leftHeight = contentHeight;
                    //页面偏移
                    var position = 0;
                    //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
                    var imgWidth = 595.28;
                    var imgHeight = (592.28 / contentWidth) * contentHeight;
                    var pageData = canvas.toDataURL("image/jpeg", 1.0);
                    var PDF = new JsPDF("", "pt", "a4");
                    if (leftHeight < pageHeight) {
                        PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
                    } else {
                        while (leftHeight > 0) {
                            PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
                            leftHeight -= pageHeight;
                            position -= 841.89;
                            if (leftHeight > 0) {
                                PDF.addPage();
                            }
                        }
                    }
                    PDF.save('测试' + ".pdf"); // 这里是导出的文件名
                });
            },
            search(){
                //console.log(this.input,this.city+this.erae+this.minerae);
                let parmas = {
                    page: this.currentPage,
                    size: this.pageSize,
                    name:this.input,
                    mobile:this.input,
                    shopName:this.input,
                    province:this.city,
                    city:this.erae,
                    area:this.minerae,
                };
                //console.log(parmas);
                findBillList(parmas).then((res) => {
                    let data = JSON.parse(res.data);
                    for(let i=0;i<data.rows.length;i++){
                        data.rows[i].area=data.rows[i].province+data.rows[i].city+data.rows[i].area;
                    }
                    this.total=data.total;
                    this.tableData=data.rows;
                });
            },
            //获取当前是第几页
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.currentPage=val;
                let parmas = {
                    page: this.currentPage,
                    size: this.pageSize,
                    name:this.input,
                    mobile:this.input,
                    shopName:this.input,
                    province:this.city,
                    city:this.erae,
                    area:this.minerae,
                };
                findBillList(parmas).then((res) => {
                    let data = JSON.parse(res.data);
                    for(let i=0;i<data.rows.length;i++){
                        data.rows[i].area=data.rows[i].province+data.rows[i].city+data.rows[i].area;
                    }
                    this.total=data.total;
                    this.tableData=data.rows;
                });
            },
            //清空
            empty(){
                this.input='';
                this.form.selectedOptions=[];
            },
            show(i,data){  //查看
                this.details=true;
                let id=data.id;
                //console.log(id);
                lookBillDetails(id).then((res) => {
                    let data = JSON.parse(res.data);

                   // data.area=data.province+data.city+data.area;
                    function getLocalTime(nS) {
                        return new Date(parseInt(nS)).toLocaleString().replace(/:\d{1,2}$/,' ');
                    }
                    data.startTime=getLocalTime(data.startTime);
                    data.endTime=getLocalTime(data.endTime);
                    this.detailsData=data;
                    this.detailsDetail=data.stockDetailResponse;
                    this.detailsData.area=this.detailsData.province+this.detailsData.city+this.detailsData.area;
                    for(let i=0;i<this.detailsDetail.length;i++){
                        this.detailsDetail[i].stockTime=getLocalTime(this.detailsDetail[i].stockTime);
                    }
                    let imgArray=[];
                    //console.log(this.detailsDetail);

                    for(let i=0;i<this.detailsDetail.length;i++){
                        if(this.detailsDetail[i].billName==null){
                            imgArray.push([])
                        }else {
                             imgArray.push(this.detailsDetail[i].billName.split(','))
                            //imgArray.push([])
                        }
                    }

                    this.detailsImgList=imgArray;
                    console.log(this.detailsData)
                });

            },
            show2(i,data){  //编辑
                //console.log(i,data);
                this.edit=true;
                let id=data.id;
                lookBillDetails(id).then((res) => {
                    let data = JSON.parse(res.data);

                    console.log(data);
                    this.editID=data.id;
                    function getLocalTime(nS) {
                        return new Date(parseInt(nS)).toLocaleString().replace(/:\d{1,2}$/,' ');
                    }
                    data.startTime=getLocalTime(data.startTime);
                    data.endTime=getLocalTime(data.endTime);
                    this.editData=data;
                    this.editData.area=this.editData.province+this.editData.city+this.editData.area;
                    let array=this.editData.stockDetailResponse;
                    this.editDetail=[];
                    for(let i=0;i<array.length;i++){
                        this.editDetail.push(array[i])
                    }
                    for(let i=0;i<this.editDetail.length;i++){
                        this.editDetail[i].stockTime=getLocalTime(this.editDetail[i].stockTime);
                    }

                    for(let i=0;i<array.length;i++){
                        if(array[i].billName==null){
                            this.editDetail[i].imgArray=[];
                        }else {
                            this.editDetail[i].imgArray=[];
                            this.editDetail[i].imgArray=array[i].billName.split(',');
                        }
                    }

                    this.editMoney=0;
                    for(let i=0;i<this.editDetail.length;i++){
                        this.editMoney+=parseInt(this.editDetail[i].stockMoney);
                    }

                });
            },
            handleClose(){  //X关闭新增
                this.add=false;
                this.uploadImg=[];
                this.businessLicense=[];
                this.form2.selectedOptions=[];
                this.mobile='';
                this.shopID='';
                this.staffAdd=[];
                this.name='';
                this.store='';
                this.area='';
                this.address='';
                this.departmentAddValue='';
                this.staffAddValue='';
                this.addStartDate='';
                this.departmentAdd=[];
                this.addEndDate='';
                this.days='';
                this.totalMoney1='';
                this.totalMoney2='';
                this.detail=[];
            },
            addClose(){    //新增窗口重置
                this.uploadImg=[];
                this.businessLicense=[];
                this.form2.selectedOptions=[];
                this.mobile='';
                this.shopID='';
                this.name='';
                this.staffAdd=[];
                this.store='';
                this.area='';
                this.address='';
                this.departmentAddValue='';
                this.staffAddValue='';
                // this.departmentAdd=[];
                this.addStartDate='';
                this.addEndDate='';
                this.days='';
                this.totalMoney1='';
                this.totalMoney2='';
                this.detail=[];
            },
            addSure(){  //确认新增
                this.add=false;
                //点击确定后清空表单

                let date1=new Date(this.addStartDate);
                let date2=new Date(this.addEndDate);
                let startTime=date1.getTime();
                let endTime=date2.getTime();


                // for(let i=0;i<this.detail.length;i++){
                //     this.detail[i].date=new Date(this.detail[i].date).getTime();
                // }

                let joinsSalesCloudStockDetails=[];
                // for(let i=0;i<this.detail.length;i++){
                //     joinsSalesCloudStockDetails.push({
                //         documentsCoding:this.detail[i].coding,
                //         stockTime:this.detail[i].date,
                //         stockMoney:this.detail[i].money
                //     })
                // }

                let aaa=this.detail;
                for(let j=0;j<aaa.length;j++){
                    let obj={};
                    obj.documentsCoding=aaa[j].coding;
                    obj.stockTime=new Date(aaa[j].date).getTime();
                    obj.stockMoney=aaa[j].money;
                    let b='';
                    for(let k=0;k<aaa[j].imgArray.length;k++){
                        b+=aaa[j].imgArray[k]+","
                    }
                    b=b.substring(0,b.length-1);
                    obj.billName=b;
                    joinsSalesCloudStockDetails.push(obj)
                }

                let addData={
                    mobile:this.mobile,
                    shopId:this.shopID,
                    departmentId:this.departmentAddValue,
                    stuffId:this.staffAddValue,
                    startTime:startTime,
                    endTime:endTime,
                    days:this.days,
                    currentTotalBalance:this.totalMoney1,
                    totalBalance:this.totalMoney2,
                    joinsSalesCloudStockDetails:joinsSalesCloudStockDetails,
                };
                console.log(addData);
                addBill(addData).then((res) => {
                    if(res.code==200 || res.code=='200'){
                        this.uploadImg=[];
                        this.businessLicense=[];
                        this.form2.selectedOptions=[];
                        this.mobile='';
                        this.shopID='';
                        this.name='';
                        this.store='';
                        this.area='';
                        this.address='';
                        this.staffAdd=[];
                        this.departmentAddValue='';
                        this.staffAddValue='';
                        this.departmentAdd=[];
                        this.addStartDate='';
                        this.addEndDate='';
                        this.days='';
                        this.totalMoney1='';
                        this.totalMoney2='';
                        this.detail=[];
                        this.$message({
                            type: 'success',
                            message: '新增成功!',
                        });
                        let parmas = {
                            page: this.currentPage,
                            size: this.pageSize,
                            name:this.input,
                            mobile:this.input,
                            shopName:this.input,
                            province:this.city,
                            city:this.erae,
                            area:this.minerae,
                        };
                        findBillList(parmas).then((res) => {
                            let data = JSON.parse(res.data);
                           // console.log(data);
                            for(let i=0;i<data.rows.length;i++){
                                data.rows[i].area=data.rows[i].province+data.rows[i].city+data.rows[i].area;
                            }
                            this.total=data.total;
                            this.tableData=data.rows;
                        });
                    }else {
                        this.$message({
                            type: 'error',
                            message: '新增失败!请正确填写信息',
                        });
                        this.uploadImg=[];
                        this.businessLicense=[];
                        this.form2.selectedOptions=[];
                        this.mobile='';
                        this.shopID='';
                        this.name='';
                        this.store='';
                        this.staffAdd=[];
                        this.area='';
                        this.departmentAdd=[];
                        this.address='';
                        this.departmentAddValue='';
                        this.staffAddValue='';
                        this.addStartDate='';
                        this.addEndDate='';
                        this.days='';
                        this.totalMoney1='';
                        this.totalMoney2='';
                        this.detail=[];
                    }
                });


            },
            addDrafts(){
                this.add=false;
                //点击确定后清空表单

                let date1=new Date(this.addStartDate);
                let date2=new Date(this.addEndDate);
                let startTime=date1.getTime();
                let endTime=date2.getTime();


                // for(let i=0;i<this.detail.length;i++){
                //     this.detail[i].date=new Date(this.detail[i].date).getTime();
                // }

                let joinsSalesCloudStockDetails=[];
                // for(let i=0;i<this.detail.length;i++){
                //     joinsSalesCloudStockDetails.push({
                //         documentsCoding:this.detail[i].coding,
                //         stockTime:this.detail[i].date,
                //         stockMoney:this.detail[i].money
                //     })
                // }

                let aaa=this.detail;
                for(let j=0;j<aaa.length;j++){
                    let obj={};
                    obj.documentsCoding=aaa[j].coding;
                    obj.stockTime=new Date(aaa[j].date).getTime();
                    obj.stockMoney=aaa[j].money;
                    let b='';
                    for(let k=0;k<aaa[j].imgArray.length;k++){
                        b+=aaa[j].imgArray[k]+","
                    }
                    b=b.substring(0,b.length-1);
                    obj.billName=b;
                    joinsSalesCloudStockDetails.push(obj)
                }

                let addData={
                    mobile:this.mobile,
                    shopId:this.shopID,
                    departmentId:this.departmentAddValue,
                    stuffId:this.staffAddValue,
                    startTime:startTime,
                    endTime:endTime,
                    days:this.days,
                    currentTotalBalance:this.totalMoney1,
                    totalBalance:this.totalMoney2,
                    joinsSalesCloudStockDetails:joinsSalesCloudStockDetails,
                };
                console.log(addData);
                addDrafts(addData).then((res) => {
                    if(res.code==200 || res.code=='200'){
                        this.uploadImg=[];
                        this.businessLicense=[];
                        this.form2.selectedOptions=[];
                        this.mobile='';
                        this.shopID='';
                        this.name='';
                        this.store='';
                        this.area='';
                        this.address='';
                        this.staffAdd=[];
                        this.departmentAddValue='';
                        this.staffAddValue='';
                        this.departmentAdd=[];
                        this.addStartDate='';
                        this.addEndDate='';
                        this.days='';
                        this.totalMoney1='';
                        this.totalMoney2='';
                        this.detail=[];
                        this.$message({
                            type: 'success',
                            message: '保存成功!',
                        });
                        let parmas = {
                            page: this.currentPage,
                            size: this.pageSize,
                            name:this.input,
                            mobile:this.input,
                            shopName:this.input,
                            province:this.city,
                            city:this.erae,
                            area:this.minerae,
                        };
                        findBillList(parmas).then((res) => {
                            let data = JSON.parse(res.data);
                            // console.log(data);
                            for(let i=0;i<data.rows.length;i++){
                                data.rows[i].area=data.rows[i].province+data.rows[i].city+data.rows[i].area;
                            }
                            this.total=data.total;
                            this.tableData=data.rows;
                        });
                    }else {
                        this.$message({
                            type: 'error',
                            message: '保存失败!请正确填写信息',
                        });
                        this.uploadImg=[];
                        this.businessLicense=[];
                        this.form2.selectedOptions=[];
                        this.mobile='';
                        this.shopID='';
                        this.name='';
                        this.store='';
                        this.staffAdd=[];
                        this.area='';
                        this.departmentAdd=[];
                        this.address='';
                        this.departmentAddValue='';
                        this.staffAddValue='';
                        this.addStartDate='';
                        this.addEndDate='';
                        this.days='';
                        this.totalMoney1='';
                        this.totalMoney2='';
                        this.detail=[];
                    }
                });
            },
            addForm(){  //打开新增窗口
                this.add=true;
                findDepartment().then((res) => {
                    let data = JSON.parse(res.data);
                    //console.log(data);
                    for(let i=0;i<data.length;i++){
                        this.departmentAdd.push(
                            {
                                value: data[i].id,
                                label: data[i].name
                            }
                        )
                    }
                });
            },
            AddRows(){  //新增一行

                var list = {
                    coding: "",
                    date:'',
                    money:'',
                    voucher:'',
                    imgArray:[],
                };
                    this.detail.push(list);

            },
            deleteRows(i,data){   //删除一行
                this.detail.splice(i, 1);
                this.totalMoney1=0;
                for(let i=0;i<this.detail.length;i++){
                    this.totalMoney1+=parseInt(this.detail[i].money);
                }
            },
            editDeleteRows(i){   //编辑框删除一行
                this.editDetail.splice(i, 1);
                this.editMoney=0;
                for(let i=0;i<this.editDetail.length;i++){
                    this.editMoney+=parseInt(this.editDetail[i].stockMoney);
                }
            },
            //编辑弹出框确认
            editSure(){
                this.edit=false;

                // let date=new Date();
                //
                // let startTime=date.getTime(this.editData.startTime);
                // let endTime=date.getTime(this.editData.endTime);
                let date1=new Date(this.editData.startTime);
                let startTime=date1.getTime();
                let date2=new Date(this.editData.endTime);
                let endTime=date2.getTime();

                let joinsSalesCloudStockDetails=[];
                 let aaa=this.editDetail;
                   for(let j=0;j<aaa.length;j++){
                       let obj={};
                       obj.documentsCoding=aaa[j].documentsCoding;
                       obj.stockTime=new Date(aaa[j].stockTime).getTime();
                       obj.stockMoney=aaa[j].stockMoney;
                       let b='';
                       for(let k=0;k<aaa[j].imgArray.length;k++){
                           b+=aaa[j].imgArray[k]+","
                       }
                       b=b.substring(0,b.length-1);
                       obj.billName=b;
                       joinsSalesCloudStockDetails.push(obj)
                   }


                let data={
                    id:this.editID,
                    mobile:this.editData.mobile,
                    startTime:startTime,
                    endTime:endTime,
                    joinsSalesCloudStockDetails:joinsSalesCloudStockDetails,
                };

                billEdit(data).then((res) => {
                    console.log(res);
                    if(res.code=='200' || res.code==200){
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        let parmas = {
                            page: this.currentPage,
                            size: this.pageSize,
                            name:this.input,
                            mobile:this.input,
                            shopName:this.input,
                            province:this.city,
                            city:this.erae,
                            area:this.minerae,
                        };
                        findBillList(parmas).then((res) => {
                            let data = JSON.parse(res.data);

                            this.total=data.total;
                            for(let i=0;i<data.rows.length;i++){
                                data.rows[i].area=data.rows[i].province+data.rows[i].city+data.rows[i].area;
                            }
                            this.tableData=data.rows;
                            //console.log(this.tableData);
                        });
                    }else {
                        this.$message({
                            message: '修改失败!请正确修改信息！',
                            type: 'error'
                        });
                        let parmas = {
                            page: this.currentPage,
                            size: this.pageSize,
                            name:this.input,
                            mobile:this.input,
                            shopName:this.input,
                            province:this.city,
                            city:this.erae,
                            area:this.minerae,
                        };
                        findBillList(parmas).then((res) => {
                            let data = JSON.parse(res.data);

                            this.total=data.total;
                            for(let i=0;i<data.rows.length;i++){
                                data.rows[i].area=data.rows[i].province+data.rows[i].city+data.rows[i].area;
                            }
                            this.tableData=data.rows;
                            //console.log(this.tableData);
                        });
                    }
                });

            },
            editAddRows(){  //编辑弹出框新增一行
                var list = {
                    billName:"",
                    documentsCoding: "",
                    id:"",
                    imgArray:[],
                    stockTime:'',
                    stockMoney:'',
                };
                this.editDetail.push(list);
            },
            uploadImgChange(file, fileList){  //上传图片change事件
                this.uploadImg.push(file.name);
                let arr=[];
                for(let i = 0;i< this.uploadImg.length;i++){
                    if(arr.indexOf(this.uploadImg[i]) < 0){
                        arr.push(this.uploadImg[i]);
                    }
                }
                this.uploadImg=arr;
            },
            uploadImgRemove(file){   //上传图片移除事件
                for (let i=0;i<=this.uploadImg.length;i++){
                    if(file.name == this.uploadImg[i]){
                        this.uploadImg.splice(i,1);
                    }
                }
            },
            handleChange(value) {  //查看地区
                this.form.city = this.form.selectedOptions[0];
                this.form.erae = this.form.selectedOptions[1];
                this.form.minerae = this.form.selectedOptions[2];
                this.getCity(value[0]);
                this.getErae(value[1]);
                this.getMinerae(value[2]);
                console.log(this.city+this.erae+this.minerae);
            },
            AddhandleChange(value) {   //新增框查看地区
                this.form2.city = this.form2.selectedOptions[0];
                this.form2.erae = this.form2.selectedOptions[1];
                this.form2.minerae = this.form2.selectedOptions[2];
                this.getCity(value[0]);
                this.getErae(value[1]);
                this.getMinerae(value[2]);
                console.log(this.addCity+this.addErae+this.addMinerae);
            },
            getCity(value){
                for(let y in this.CityInfo){
                    if(this.CityInfo[y].value == value){
                        this.city = this.CityInfo[y].label;
                        this.addCity = this.CityInfo[y].label;
                        //省
                    }
                }
            },
            getErae(value){
                for(let y in this.CityInfo){
                    for(let z in this.CityInfo[y].children){
                        if(this.CityInfo[y].children[z].value == value && value!=undefined){
                            this.erae = this.CityInfo[y].children[z].label;
                            this.addErae = this.CityInfo[y].children[z].label;
                            //市
                        }
                    }
                }
            },
            getMinerae(value){
                for(let y in this.CityInfo){
                    for(let z in this.CityInfo[y].children){
                        for(let i in this.CityInfo[y].children[z].children){
                            if(this.CityInfo[y].children[z].children[i].value == value && value!=undefined){
                                this.minerae = this.CityInfo[y].children[z].children[i].label;
                                this.addMinerae = this.CityInfo[y].children[z].children[i].label;
                                //区
                            }
                        }
                    }
                }
            },
            func (shopId){
                console.log(shopId)
                this.$router.push({ name: "客户账户进货对账单记录", path: "/sales/checkDetail" ,query:{ shopId:shopId}});
            }
        },
    }
</script>

<style scoped>
    #box{
        width: 98%;
        height: auto;
        background: white;
        margin-left: 10px;
        border-radius: 5px;
        overflow: hidden;
    }
</style>